module.exports = __webpack_public_path__ + "static/08-JAPON.f822ec10.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/players/08-JAPON.png
// module id = 699
// module chunks = 35783957827783